import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { Badge } from 'components';
import { useFeatureFlags } from 'utils/features';
import { t } from 'utils/localize';

export interface IProBadgeProps {
  className?: ClassName;
}

export default function ProBadge({ className }: IProBadgeProps) {
  const isPro = useFeatureFlags('PRO');
  if (isPro) {
    return null;
  }

  const classes = classNames('pro-badge', className);
  return <Badge className={classes}>{t('PRO')}</Badge>;
}
